import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  href?: string;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  href = '#pricing'
}: CTAButtonProps) {
  const ButtonContent = <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} animate={{
    boxShadow: ['0px 0px 0px 0px rgba(251, 133, 0, 0)', '0px 0px 20px 5px rgba(251, 133, 0, 0.4)', '0px 0px 0px 0px rgba(251, 133, 0, 0)']
  }} transition={{
    duration: 2,
    repeat: Infinity,
    repeatType: 'reverse'
  }} onClick={onClick} className={`relative flex items-center justify-center w-full bg-naranja-500 hover:bg-naranja-600 text-white font-heading font-bold text-lg md:text-xl py-5 px-12 rounded-full shadow-lg transition-colors whitespace-nowrap ${className}`} data-id="element-286">
      <span className="mr-2" data-id="element-287">{children}</span>
      <ChevronRight className="w-6 h-6" data-id="element-288" />
    </motion.button>;
  if (href) {
    return <a href={href} className="inline-block w-full md:w-auto no-underline" data-id="element-289">
        {ButtonContent}
      </a>;
  }
  return ButtonContent;
}